var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-px h-20 mr-6 opacity-50 bg-oLighterGray",style:(("height: " + (this.height)))})}
var staticRenderFns = []

export { render, staticRenderFns }